import React from "react";
import { Link } from "react-router-dom";
export default function ChatsList(props) {
  const chatsList = props.chats || [];
  if (!Array.isArray(chatsList)) return null;

  const ChatAvatar = () => {
    return (
      <div className="symbol symbol-circle symbol-40">
        <span class="symbol-label font-size-h5">A</span>
      </div>
    );
  };

  return (
    <>
      {chatsList.map((chat) => {
        return (
          <Link key={chat.id} to={`/chat/${chat.id}/`}>
            <div
              className={`d-flex py-4 px-2 align-items-center ${
                props.chatId === chat.id ? "bg-light" : ""
              } bg-hover-light`}
            >
              <ChatAvatar />
              <div className="mx-3 text-dark-75">{chat.name}</div>
            </div>
          </Link>
        );
      })}
    </>
  );
}
